var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBxsCloudUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3654 10.186C16.9648 7.03087 14.2634 4.58337 11 4.58337C8.47371 4.58337 6.27921 6.06012 5.27729 8.38754C3.30829 8.97604 1.83337 10.835 1.83337 12.8334C1.83337 15.3606 3.88946 17.4167 6.41671 17.4167H16.5C18.5222 17.4167 20.1667 15.7722 20.1667 13.75C20.1653 12.9283 19.8886 12.1308 19.3808 11.4848C18.8731 10.8388 18.1635 10.3815 17.3654 10.186ZM11.9167 12.8334V15.5834H10.0834V12.8334H7.33337L11 8.25004L14.6667 12.8334H11.9167Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxsCloudUpload);
export default __webpack_public_path__ + "static/media/bxs_cloud-upload.25e2fe2740ae38d58a264bec5f46b94b.svg";
export { ForwardRef as ReactComponent };